export const shadows = {
  sm: "2px 2px 12px 5px rgba(240, 240, 240, 1)",
}
